import React from 'react';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import {
  columnCode, columnDescription, columnMultiSelect, columnNameLink, columnTools, columnVisibility,
} from '@/constants/fields';
import urls, { relativeUrl } from '@/constants/urls';
import { presentationOptions } from '@/constants/states';
import { fitToPage, goToCategoryPage } from '@/hooks/paging';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import ToggleCardsButton from '@/components/cards/ToggleCardsButton';
import SearchesFilters from '../containers/SearchesFilters';
import SearchesTableRows from './SearchesTableRows';
import SearchesTableHeader from './SearchesTableHeader';

const SearchesTable = ({
  category,
  columns = [columnMultiSelect, columnNameLink, columnCode, columnDescription, columnVisibility, columnTools],
  currentPage,
  fetchData,
  hideColumns,
  onCheckBoxClick,
  readErrors,
  pageCount,
  pageSize,
  readStatus,
  searches,
  togglePresentation,
  total,
}) => {
  const { items, pageNumber } = fitToPage(searches, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <div className="ReactTable" ref={ref}>
      <TableWrapper sticky celled className="aridhia-searches-table" columns={columns}>
        <SearchesTableHeader
          category={category}
          columns={columns}
          hideColumns={hideColumns}
          loaderButton={!hideColumns}
          readErrors={readErrors}
          readStatus={readStatus}
          searches={items}
        >
          {togglePresentation && (readStatus !== states.PENDING) && (
          <ToggleCardsButton
            display={presentationOptions.TABLE}
            disabled={readStatus === states.PENDING}
            onClick={() => togglePresentation(category, presentationOptions.CARDS)}
          />
          )}
          <SearchesFilters category={category} className="aridhia-table-filter" />
        </SearchesTableHeader>
        <Table.Body>
          <SearchesTableRows category={category} items={items} columns={columns} onCheckBoxClick={onCheckBoxClick} />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        canCreate
        currentPage={pageNumber}
        entity="search"
        goToPage={({ page }) => goToCategoryPage(fetchData, category, page, ref)}
        icon="filter"
        items={items}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
        url={`#${relativeUrl(urls.SEARCH)}`}
      />
    </div>
  );
};

export default SearchesTable;
